var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.evento_id)?_c('v-container',[_c('CuponDialog',{attrs:{"evento_id":_vm.evento_id},on:{"saveCupon":$event => { _vm.refrescarCupones() }}}),_c('CuponesTabla',{ref:"cuponesTabla",attrs:{"evento_id":_vm.evento_id}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }